import {
  SET_SLOT_NAME,
  DELETE_SLOT,
  REVERT_SLOT,
  SET_GROUP_ORDER,
  SET_SUMMARY_ORDER,
  SET_GROUP_COLUMN,
  SET_SUMMARY_COLUMN
} from './actionTypes';

export const setSlotNameById = (id, name) => ({
  type: SET_SLOT_NAME,
  payload: {
    id,
    name
  }
});

export const revertSlotById = id => ({
  type: REVERT_SLOT,
  payload: { id }
});

export const deleteSlotById = id => ({
  type: DELETE_SLOT,
  payload: { id }
});

export const setGroupColumn = (id, column) => ({
  type: SET_GROUP_COLUMN,
  payload: { id, column }
});

export const setGroupColumnOrder = (id, order) => ({
  type: SET_GROUP_ORDER,
  payload: { id, order }
});

export const setSummaryColumn = (id, column) => ({
  type: SET_SUMMARY_COLUMN,
  payload: { id, column }
});

export const setSummaryColumnOrder = (id, order) => ({
  type: SET_SUMMARY_ORDER,
  payload: { id, order }
});



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/flow/actions.js